import type { Pitfall } from '@hysys-uv/shared';

interface Props {
  pitfalls: Pitfall[];
}

const SEVERITY_STYLES: Record<Pitfall['severity'], string> = {
  info: 'border-blue-900/40 bg-blue-900/10 text-blue-300',
  warning: 'border-yellow-900/40 bg-yellow-900/10 text-yellow-300',
  critical: 'border-red-900/40 bg-red-900/10 text-red-300',
};

export function PitfallsPanel({ pitfalls }: Props): JSX.Element {
  if (pitfalls.length === 0) {
    return <p className="text-neutral-500 text-sm">No pitfalls surfaced.</p>;
  }
  return (
    <ul className="space-y-3">
      {pitfalls.map((p, i) => (
        <li key={i} className={`border rounded-md p-3 ${SEVERITY_STYLES[p.severity]}`}>
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs uppercase tracking-wide">{p.severity}</span>
            <span className="text-sm font-medium text-neutral-100">{p.title}</span>
          </div>
          <p className="text-sm text-neutral-300">{p.description}</p>
        </li>
      ))}
    </ul>
  );
}
